import type { Locale, RouteKind } from "../content/types";

// zh 路径沿用简体 slug（不改成 zh-Hans）：App 已发布版本的法务链接和搜索引擎收录都指向 /zh/*，
// 改名等于自己砸掉现有收录，繁体新增用独立的 zh-Hant 路径即可。
export const localizedPaths: Record<RouteKind, Record<Locale, string>> = {
  landing: {
    en: "/",
    zh: "/zh",
    "zh-Hant": "/zh-Hant"
  },
  privacy: {
    en: "/privacy",
    zh: "/zh/privacy",
    "zh-Hant": "/zh-Hant/privacy"
  },
  support: {
    en: "/support",
    zh: "/zh/support",
    "zh-Hant": "/zh-Hant/support"
  },
  terms: {
    en: "/terms",
    zh: "/zh/terms",
    "zh-Hant": "/zh-Hant/terms"
  }
};

export function getPath(kind: RouteKind, locale: Locale) {
  return localizedPaths[kind][locale];
}
